import React, { useEffect, useState } from 'react';
import './News.css';

const News = () => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const slides = [
    {
      img: '/images/news-images/founders.webp',
      quote:
        'A trio of undergraduates teamed up to bring accessible, high-quality education consulting services to the community. Now, they are branching out beyond Rochester.',
      author: 'Jim Mandelero · University of Rochester News Center',
      more: 'Read the feature',
      link: 'https://www.rochester.edu/newscenter/educational-consultants-services-college-admissions-603272/'
    },
    {
      img: '/images/news-images/spectrum.webp',
      quote:
        '“Project LTF organizers are paying it forward and paving the way for others to have the same opportunity.”',
      author: 'Adriana Loh · Spectrum News',
      more: 'Watch the story',
      link: 'https://spectrumlocalnews.com/nys/rochester/news/2023/10/21/student-led-project-levels-the-field-for-equal-educational-opportunities'
    },
    {
      img: '/images/news-images/eventimg2.webp',
      quote:
        '“Supplementing school counselor workloads and providing new avenues for college and career exploration, LTF fulfills a vast need in the Rochester community, and looks to expand at the university level.”',
      author: 'Ritu Pedddinti · Campus Times',
      more: 'Read the article',
      link: 'https://www.campustimes.org/2023/10/22/project-ltf-presents-at-local-high-school-expands-to-university/'
    },
    {
      img: '/images/news-images/eventimg1.webp',
      quote:
        '“Congratulations to the students of Project Level the Field, helping high school students overcome barriers to applying to college.”',
      author: 'University of Rochester · via X/Twitter',
      more: 'View the post',
      link: 'https://twitter.com/UofR/status/1719061077634195490'
    },
    {
      img: '/images/news-images/rochnews.svg',
      quote: '“Local stations continue to spotlight Project LTF’s student-led mentorship model.”',
      author: 'ABC Rochester',
      more: 'Watch the segment',
      link: 'https://www.youtube.com/live/xcLruchrsiMB_M?t=5806&feature=shared'
    }
  ];

  const goToSlide = (index) => {
    setCurrentSlideIndex((index + slides.length) % slides.length);
  };

  const nextSlide = () => goToSlide(currentSlideIndex + 1);
  const prevSlide = () => goToSlide(currentSlideIndex - 1);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlideIndex((prev) => (prev + 1) % slides.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const activeSlide = slides[currentSlideIndex];

  return (
    <div className="news-page">
      <section className="news-hero">
        <p className="news-hero__badge">Press & Updates</p>
        <h1>Stories about the students changing college access.</h1>
        <p>
          From regional newscasts to university publications, Project LTF’s student leaders are regularly
          featured for their work in mentoring and training the next generation of scholars. Explore a few of
          our recent highlights.
        </p>
      </section>

      <section className="news-feature">
        <div className="news-feature__media">
          <img src={activeSlide.img} alt={activeSlide.author} loading="lazy" />
          <div className="news-feature__controls">
            <button type="button" onClick={prevSlide} aria-label="Previous story">
              &#10094;
            </button>
            <button type="button" onClick={nextSlide} aria-label="Next story">
              &#10095;
            </button>
          </div>
          <div className="news-feature__counter">
            {currentSlideIndex + 1} / {slides.length}
          </div>
        </div>
        <div className="news-feature__details">
          <p className="news-feature__quote">{activeSlide.quote}</p>
          <p className="news-feature__author">{activeSlide.author}</p>
          <a
            className="news-feature__link"
            href={activeSlide.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {activeSlide.more}
          </a>
        </div>
      </section>

      <div className="news-thumbs">
        {slides.map((slide, index) => (
          <button
            type="button"
            key={slide.author}
            className={`news-thumb ${index === currentSlideIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          >
            <img src={slide.img} alt={slide.author} loading="lazy" />
            <div>
              <p>{slide.author}</p>
              <span>{slide.more}</span>
            </div>
          </button>
        ))}
      </div>

      <section className="news-social-placeholder">
        <div className="news-social__intro">
          <p className="news-social__eyebrow">Coming Soon</p>
          <h2>Social updates</h2>
          <p>
            Our Instagram highlights will relaunch shortly. Check back soon for real-time coverage, team
            takeovers, and mentor stories.
          </p>
        </div>
      </section>
    </div>
  );
};

export default News;
